import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/event/call/icon1_pc.png'
import _imports_1 from '@/assets/img/event/call/icon2_pc.png'
import _imports_2 from '@/assets/img/event/call/cafe&Barcall_logo.png'
import _imports_3 from '@/assets/img/event/call/call_talent1.jpeg'
import _imports_4 from '@/assets/img/event/call/call_talent2.jpeg'
import _imports_5 from '@/assets/img/event/call/call_talent3.jpeg'
import _imports_6 from '@/assets/img/event/call/app_store.png'
import _imports_7 from '@/assets/img/event/call/google_play.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-b42fe5ec")

_pushScopeId("data-v-b42fe5ec")
const _hoisted_1 = { class: "office-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "visual" }, null, -1)
const _hoisted_3 = { class: "call-main" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "call-top-icon" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "call-top-icon-item",
    href: "http://call-kimono.com/cafe_bar.html",
    target: "_blank"
  }, [
    /*#__PURE__*/_createVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createVNode("a", {
    class: "call-top-icon-item",
    href: "https://www.instagram.com/cafebar_call/?utm_medium=copy_link",
    target: "_blank"
  }, [
    /*#__PURE__*/_createVNode("img", { src: _imports_1 })
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "call-info" }, [
  /*#__PURE__*/_createVNode("p", { class: "call-info-text" }, [
    /*#__PURE__*/_createTextVNode("『call』着物を着たインフルエンサー（響万里菜、西菜まな、仁王頭かおりの3名）と"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("『onlylive』で1対1のビデオ通話ができるイベントを開催！"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("着物を着たインフルエンサーと2人きりのトークを楽しもう！"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("（11月5日(金)~11月7日(日) 20:30~21:30）"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("11月5日(金)〜11月7日(日)の17:00から20:00までは『cafe&bar call』で"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("『call』着物を着て響万里菜、西菜まな、仁王頭かおりが1日交代で店長をやるよ！")
  ]),
  /*#__PURE__*/_createVNode("p", { class: "sp-call-info-text" }, [
    /*#__PURE__*/_createTextVNode("『call』着物を着たインフルエンサー"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("（響万里菜、西菜まな、仁王頭かおりの3名）と"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("『onlylive』で1対1のビデオ通話ができる"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("イベントを開催！"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("着物を着たインフルエンサーと2人きりの"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("トークを楽しもう！"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("（11月5日(金)~11月7日(日) 20:30~21:30）"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("11月5日(金)〜11月7日(日)の17:00から20:00までは"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("『cafe&bar call』で『call』着物を着て"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("響万里菜、西菜まな、仁王頭かおりが1日交代で"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("店長をやるよ！")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "guid-store" }, "▼お店はこちら", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("a", {
  class: "guid-store-link",
  href: "http://call-kimono.com/cafe_bar.html",
  target: "_blank"
}, [
  /*#__PURE__*/_createVNode("img", {
    class: "guid-store-logo",
    src: _imports_2
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "call-talent-list" }, [
  /*#__PURE__*/_createVNode("p", { class: "call-title" }, "タレント一覧"),
  /*#__PURE__*/_createVNode("div", { class: "call-talent-list-images" }, [
    /*#__PURE__*/_createVNode("a", {
      class: "call-talent-list-item",
      href: "https://onlylive.jp/talent/6fe767ea-9bbf-47d0-be63-b09b305388d5",
      target: "_blank"
    }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_3 }),
      /*#__PURE__*/_createVNode("p", null, "響万里菜")
    ]),
    /*#__PURE__*/_createVNode("a", {
      class: "call-talent-list-item",
      href: "https://onlylive.jp/talent/4b6fec12-80df-41ab-bc4d-365ee91c9486",
      target: "_blank"
    }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_4 }),
      /*#__PURE__*/_createVNode("p", null, "西菜まな")
    ]),
    /*#__PURE__*/_createVNode("a", {
      class: "call-talent-list-item",
      href: "https://onlylive.jp/talent/6c7c4393-d572-423c-94c4-85922f7e3046",
      target: "_blank"
    }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_5 }),
      /*#__PURE__*/_createVNode("p", null, "仁王頭かおり")
    ])
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "call-schedule" }, [
  /*#__PURE__*/_createVNode("p", { class: "call-title" }, "onlylive配信スケジュール"),
  /*#__PURE__*/_createVNode("div", { class: "call-schedule-list" }, [
    /*#__PURE__*/_createVNode("div", { class: "call-schedule-list-item" }, [
      /*#__PURE__*/_createVNode("p", { class: "call-schedule-date" }, "11/5"),
      /*#__PURE__*/_createVNode("p", { class: "call-schedule-talent" }, "響万里菜")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "call-schedule-list-item" }, [
      /*#__PURE__*/_createVNode("p", { class: "call-schedule-date" }, "11/6"),
      /*#__PURE__*/_createVNode("p", { class: "call-schedule-talent" }, "西菜まな")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "call-schedule-list-item" }, [
      /*#__PURE__*/_createVNode("p", { class: "call-schedule-date" }, "11/7"),
      /*#__PURE__*/_createVNode("p", { class: "call-schedule-talent" }, "仁王頭かおり")
    ])
  ]),
  /*#__PURE__*/_createVNode("p", { class: "call-schedule-supplement" }, [
    /*#__PURE__*/_createTextVNode("※17:00-20:00に１日店長イベントを行い、"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("20:30 -21:30にonlyliveにて1対１のビデオ通話を始めます。")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "event-preparation-join" }, [
  /*#__PURE__*/_createVNode("p", { class: "call-title" }, "▼イベントの参加準備"),
  /*#__PURE__*/_createVNode("div", { class: "preparation-join-content" }, [
    /*#__PURE__*/_createVNode("p", { class: "preparation-join-howto" }, "①onlyliveのアプリをダウンロード"),
    /*#__PURE__*/_createVNode("p", { class: "preparation-join-howto-detail" }, [
      /*#__PURE__*/_createTextVNode("下記のボタンからアプリをダウンロードして"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("無料会員登録を済ませておきましょう。")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "call-onlylive-app-store" }, [
      /*#__PURE__*/_createVNode("a", {
        class: "app-store-link",
        href: "https://apps.apple.com/jp/app/onlylive/id1554615532",
        target: "_blank"
      }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_6 })
      ]),
      /*#__PURE__*/_createVNode("a", {
        class: "app-store-link",
        href: "https://play.google.com/store/apps/details?id=com.ILEO.onlylive",
        target: "_blank"
      }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_7 })
      ])
    ]),
    /*#__PURE__*/_createVNode("p", { class: "preparation-join-howto" }, "②話したいタレントをお気に入り登録"),
    /*#__PURE__*/_createVNode("p", { class: "preparation-join-howto-detail" }, "お気に入り登録すると通知が届くようになります。"),
    /*#__PURE__*/_createVNode("p", { class: "preparation-join-howto" }, "③あらかじめ通話分のコインを購入"),
    /*#__PURE__*/_createVNode("p", { class: "preparation-join-howto-detail" }, [
      /*#__PURE__*/_createTextVNode("あらかじめ通話用のコインを購入しておくと"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("スムーズに通話ができます！"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("たくさんお話ししたい場合はコインを多めに"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("用意しておきましょう。")
    ])
  ])
], -1)
const _hoisted_11 = { class: "call-usecase" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Usecase = _resolveComponent("Usecase")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_Usecase)
      ])
    ])
  ]))
})